import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { AuthService, UserInfo } from '../../../../providers/auth.provider';
import { CONST } from '../../../../providers/const';
import { UtilitiesService } from '../../../../providers/utilities.provider';

@Component({
  selector: 'ngx-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit {
  @Input() user: UserInfo;
  @Input() picture: any = 'assets/img/no-photo.png';
  @Output() onAction: EventEmitter<any> = new EventEmitter();
  flipped = false;
  availableRoles: any[] = [];
  showRolesButton = false;
  profileIncomplete = true;

  public role = '';

  constructor(
    private nbDialog: NbDialogService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.authService.getRolesStatus(this.user.id).toPromise()
      .then((rolesStatus: any[]) => {
        this.user.roles ? null : this.user.roles = [];
        this.role = this.user.role.split('_').length > 1 ? this.user.role.split('_').join(' ') : this.user.role;
        for (let index = 0; index < this.user.roles.length; index++) {
          let element = this.user.roles[index];
          let roleStatus = rolesStatus.find(f => f.role.toLowerCase() == element.value.toLowerCase());
          element.selected = element.value.toLowerCase() == this.user.role.toLowerCase();
          element.complete = rolesStatus ? roleStatus.status == "UV" ? true : false : false;
          this.availableRoles.push(element)
        }

        if (this.user.role != CONST.ROLES.stf_staff && this.user.role != CONST.ROLES.admin) {
          this.showRolesButton = true;
        }

        this.profileIncomplete = this.user.step != CONST.PROFILE_STEP.complete;
      })
  }

  changeRole(role) {
    this.onAction.emit({ action: 'change-role', role: role })
  }

  action(action) {
    this.onAction.emit({ action: action })

  }
}
